import { Link } from 'react-router-dom';
import { AppleCategories } from './AppleStore';
const AppleProductList = () => {
  return (
    <div className="apple-product-list">
      <div className="store-title">
        {/* <p>
          Apple <strong>Store</strong>
        </p> */}
      </div>
      <div className="product-list">
        {AppleCategories?.map((category) => (
          <div key={category.id}>
            <Link
              className="apple-Link-categories"
              to={`${category.path}/${category.type}`}
              blank="target"
            >
              <div
                className="product-img "
                // style={{ backgroundImage: `url(${category.image})` }}
              >
                <img src={category.image} alt="img" />
              </div>
              <span className="product-list-name">{category.name}</span>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AppleProductList;
